import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSlideNavigation } from '../hooks/useSlideNavigation';
import { SwimmingFish } from './animations/SwimmingFish';
import { Slide01Cover } from './slides/Slide01Cover';
import { Slide02AttentionWar } from './slides/Slide02AttentionWar';
import { Slide03MarketTruth } from './slides/Slide03MarketTruth';
import { Slide04SamplingBroken } from './slides/Slide04SamplingBroken';
import { Slide05WhyNow } from './slides/Slide05WhyNow';
import { Slide06Ecosystem } from './slides/Slide06Ecosystem';
import { Slide07FinnsExperience } from './slides/Slide07FinnsExperience';
import { Slide08BrandBenefits } from './slides/Slide08BrandBenefits';
import { Slide09DigitalService } from './slides/Slide09DigitalService';
import { Slide10CoBrand } from './slides/Slide10CoBrand';
import { Slide11SponsrAI } from './slides/Slide11SponsrAI';
import { Slide12Measurement } from './slides/Slide12Measurement';
import { Slide13RedeemPartners } from './slides/Slide13RedeemPartners';
import { Slide14MarketPotential } from './slides/Slide14MarketPotential';
import { Slide15Traction } from './slides/Slide15Traction';
import { Slide16BusinessModel } from './slides/Slide16BusinessModel';
import { Slide17GoToMarket } from './slides/Slide17GoToMarket';
import { Slide18CapitalUse } from './slides/Slide18CapitalUse';
import { Slide19WhyInvest } from './slides/Slide19WhyInvest';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [Slide01Cover, Slide02AttentionWar, Slide03MarketTruth, Slide04SamplingBroken, Slide05WhyNow, Slide06Ecosystem, Slide07FinnsExperience, Slide08BrandBenefits, Slide09DigitalService, Slide10CoBrand, Slide11SponsrAI, Slide12Measurement, Slide13RedeemPartners, Slide14MarketPotential, Slide15Traction, Slide16BusinessModel, Slide17GoToMarket, Slide18CapitalUse, Slide19WhyInvest];
export function PitchDeck() {
  const {
    currentSlide,
    direction,
    nextSlide,
    prevSlide,
    goToSlide
  } = useSlideNavigation(slides.length);
  const CurrentSlideComponent = slides[currentSlide];
  return <div className="relative w-full h-screen bg-gradient-to-b from-[#0a4d4d] to-[#0d5858] overflow-hidden text-white font-sans" data-id="element-15">
      {/* Minimal Background Elements - 70% reduction */}
      <SwimmingFish delay={0} duration={40} yRange={[20, 60]} scale={0.5} className="opacity-30 top-10 right-10" data-id="element-16" />

      {/* Grid overlay for dashboard feel */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:100px_100px] pointer-events-none" data-id="element-17" />

      {/* Main Content Area */}
      <div className="relative w-full h-full flex items-center justify-center p-8 md:p-16" data-id="element-18">
        <AnimatePresence mode="wait" custom={direction} data-id="element-19">
          <motion.div key={currentSlide} custom={direction} initial={{
          opacity: 0,
          x: direction * 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: direction * -50
        }} transition={{
          duration: 0.4,
          ease: 'easeInOut'
        }} className="w-full max-w-7xl h-full flex flex-col" data-id="element-20">
            <CurrentSlideComponent data-id="element-21" />
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Navigation Controls */}
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 p-4 rounded-full bg-white/5 hover:bg-white/10 transition-colors z-50 group border border-white/10" aria-label="Previous slide" data-id="element-22">
        <ChevronLeft className="w-8 h-8 text-white/50 group-hover:text-[#ffd700] transition-colors" data-id="element-23" />
      </button>

      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 p-4 rounded-full bg-white/5 hover:bg-white/10 transition-colors z-50 group border border-white/10" aria-label="Next slide" data-id="element-24">
        <ChevronRight className="w-8 h-8 text-white/50 group-hover:text-[#ffd700] transition-colors" data-id="element-25" />
      </button>

      {/* Progress Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-50" data-id="element-26">
        {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${currentSlide === index ? 'w-8 bg-[#ffd700]' : 'w-2 bg-white/20 hover:bg-white/40'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-27" />)}
      </div>

      {/* Slide Counter */}
      <div className="absolute bottom-8 right-8 text-white/30 font-mono text-sm" data-id="element-28">
        {currentSlide + 1} / {slides.length}
      </div>
    </div>;
}